<template>
  <v-container fluid>
    <v-row>
      <v-col
        class="col-12 col-sm-6 col-md-3 col-lg-3"
        v-for="(image, index) in images"
        :key="image.Location"
      >
        <v-card class="pa-2" @click="$emit('imageclick', image)">
          <v-img
            :src="image.Location"
            aspect-ratio="1"
            class="mx-auto"
            contain=""
            @error="removeImage(index)"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import service from "@/services/index.js";
export default {
  data: () => ({
    images: ["a", "a", "a", "a", "a", "a", "a", "a"]
  }),
  methods: {
    async onLoad() {
      this.images = await service.image.get();
    },
    removeImage(index) {
      this.images.splice(index, 1);
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>

<style></style>
